import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import CustomModal from 'src/components/CustomModal';
import LoadingIndicator from 'src/components/LoadingIndicator';

import useStyles from './styles';
import getClientMode from 'src/store/utils-store/selectors';
import { useSelector } from 'react-redux';

function PDFViewerModal(props) {
  const {
    showModal,
    fileName,
    onClosePress,
    fileURLs,
    loading,
    errorMessage,
  } = props;

  const classes = useStyles();
  const isModeDark = useSelector(getClientMode());

  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (showModal) setIndex(0);
  }, [showModal, fileURLs]);

  const hasFiles = Array.isArray(fileURLs) && fileURLs.length > 0;
  const currentFile = hasFiles ? fileURLs[index] : null;

  return (
    <CustomModal
      showModal={showModal}
      title={hasFiles ? `DJ Firmada ${index + 1}/${fileURLs.length}` : fileName}
      onClosePress={onClosePress}
      maxWidth="lg"
      fullWidth
      hideScroll
    >
      {loading ? (
        <div className={classes.loadingContainer}>
          <LoadingIndicator />
        </div>
      ) : hasFiles ? (
        <>
          <object
            data={currentFile}
            type="application/pdf"
            className={classes.pdfContaier}
          >
            <embed src={currentFile} type="application/pdf" />
            <div className={classes.loadingContainer}>
              <h4>
                En caso no pueda ver el documento, pruebe con un navegador
                diferente.
              </h4>
            </div>
          </object>

          {/* controles */}
          {fileURLs.length > 1 && (
            <div className={classes.controls}>
              <button
                disabled={index === 0}
                onClick={() => setIndex(i => i - 1)}
              >
                ◀ Anterior
              </button>

              <button
                disabled={index === fileURLs.length - 1}
                onClick={() => setIndex(i => i + 1)}
              >
                Siguiente ▶
              </button>
            </div>
          )}
        </>
      ) : (
        <div className={classes.loadingContainer}>
          <h4 className={classes.error}>{errorMessage}</h4>
        </div>
      )}
    </CustomModal>
  );
}

PDFViewerModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClosePress: PropTypes.func.isRequired,
  fileName: PropTypes.string.isRequired,
  fileURLs: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
};

PDFViewerModal.defaultProps = {
  fileURLs: [],
  errorMessage:
    'Ocurrió un error obteniendo el documento, inténtelo más tarde.',
};

export default PDFViewerModal;
